import React, { useState } from "react";
import { connect } from "react-redux";
import { ICommonPageContent } from "app/api/types";

import { uploadImg, deleteImg } from "app/api/redux/PageContent/actions";

import "./styles.scss";

interface IProps {
  name: string;
  content: ICommonPageContent;
  handleChange: (e: any) => void;
  handleSubmit: () => void;
  readOnly?: boolean;
}

interface IReduxProps {
  uploadImg: (data: any) => Promise<string>;
  deleteImg: (name: string) => Promise<string>;
}

const ImgUpload: React.FC<IProps & IReduxProps> = ({
  content,
  handleChange,
  handleSubmit,
  uploadImg,
  deleteImg,
  name,
  readOnly,
}) => {
  const [src, setSrc] = useState(content.src);
  const imgUrl = `${process.env.REACT_APP_API_HOST}/static/${src}`;

  const handleFileUpload = (event: any) => {
    let data = new FormData();

    data.append("file", event.target.files[0]);

    uploadImg(data)
      .then((resName: string) => {
        handleChange({ target: { value: resName, name } });
        handleSubmit();
        setSrc(resName);
      })
      .catch((err) => console.log(err));
  };

  const handleImgDelete = (imGname: string) => {
    deleteImg(imGname)
      .then((response: string) => {
        handleChange({ target: { value: "", name } });
        handleSubmit();
        setSrc("");
      })
      .catch((err: any) => console.log(err));
  };

  return (
    <div className="form-row img-upload">
      <div className="img-upload__field">
        <input
          type="text"
          value={content.src}
          name={name}
          placeholder="имя изображения"
          onChange={handleChange}
          className="field__input"
          readOnly={readOnly}
        />

        {src && (
          <button
            className="field__label"
            onClick={() => handleImgDelete(src!)}
          >
            удалить
          </button>
        )}
        {!src && (
          <label htmlFor={`img-input-${content.id}`} className="field__label">
            загрузить
          </label>
        )}
      </div>

      <input
        className="img-upload__file-input"
        id={`img-input-${content.id}`}
        type="file"
        onChange={handleFileUpload}
      />
      {src && (
        <div
          style={{
            background: `url(${imgUrl}) no-repeat`,
            height: "300px",
            width: "300px",
            backgroundSize: "contain",
            marginTop: "20px",
          }}
        />
      )}
    </div>
  );
};

export default connect(null, { uploadImg, deleteImg })(ImgUpload);
